import _ from 'lodash';
import { types, actionIDs } from 'legacy/actions/paymentActions';
import { types as userTypes } from 'legacy/actions/userActions';
import { toActionID } from '../util/util';

export const initialState = {
  cards: [],
  errors: _.mapValues(types, () => ({})),
  loading: _.mapValues(types, () => false)
};

// Allow specific sister types from other actions
const SISTER_TYPES = [
  userTypes.LOGOUT.success,
  userTypes.GET_MY_PROFILE.success,
  userTypes.CUSTOM_REGISTER.success,
  userTypes.INITIAL_LOGIN.success,
  userTypes.APPLE_LOGIN.success
];

export function paymentReducer(state = initialState, action) {
  const actionID = toActionID(action.type);
  if (!actionIDs.includes(actionID) && !SISTER_TYPES.includes(action.type)) {
    return state;
  }
  const newState = _.cloneDeep(state);
  if (actionIDs.includes(actionID)) {
    newState.errors[actionID] = {};
    newState.loading[actionID] = false;
  }
  switch (action.type) {
    case userTypes.LOGOUT.success:
      return initialState;
    case userTypes.GET_MY_PROFILE.success:
    case userTypes.CUSTOM_REGISTER.success:
    case userTypes.INITIAL_LOGIN.success:
    case userTypes.APPLE_LOGIN.success:
      newState.cards = action.payload.user.cards || [];
      return newState;
    case types.STRIPE_CARD.error:
      newState.loading[types.ADD_CARD.id] = false;
      newState.loading[types.EDIT_CARD.id] = false;
      return newState;
    case types.ADD_CARD.success:
      // eslint-disable-next-line no-case-declarations
      const newCard = {
        ...action.payload.card,
        stripe_id:
          action.payload.card.stripe_id || action.payload.card.stripeId,
        _id: action.payload.card._id || action.payload.card.id,
        last4: action.payload.card.last4 || action.payload.card.last4Digits
      };
      // eslint-disable-next-line no-case-declarations
      const newCards = [...newState.cards, newCard];

      newState.cards = newCards;
      return newState;
    case types.DELETE_CARD.success:
      newState.cards = action.payload;
      return newState;
    case types.SET_DEFAULT_CARD.success:
      return {
        ...newState,
        cards: newState.cards.map((card) => ({
          ...card,
          default: card._id === action.payload.defaultSource
        }))
      };
    default:
      if (action.type.endsWith('START')) {
        newState.loading[actionID] = true;
      } else if (action.type.endsWith('ERROR')) {
        newState.errors[actionID] = action.payload.error;
      }
      return newState;
  }
}

export default { initialState, reducer: paymentReducer };
